import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

/**
 * V2 triage sub-agent types - matches TriageV2AgentType
 */
export const triageV2AgentTypes = [
  "returns",
  "marketing",
  "oms",
  "analytics",
  "shopper-ai",
] as const;

export const getTriageV2Threads = {
  name: "getTriageV2Threads" as const,

  input: z.object({
    searchQuery: z.string().optional(),
    calledAgentFilter: createEnum(triageV2AgentTypes).optional(),
    escalationFilter: createEnum(["yes", "no"]).optional(),
    dateRange: z
      .object({ start: z.date().nullable(), end: z.date().nullable() })
      .optional(),
    page: z.number().min(1).default(1),
    pageSize: z.number().min(1).max(100).default(20),
  }),

  output: z.object({
    data: z.array(
      z.object({
        _id: z.string(),
        teamId: z.string().optional(),
        teamName: z.string().optional(),
        messageCount: z.number().optional(),
        totalTokens: z.number().optional(),
        createdAt: z.date(),
        updatedAt: z.date().optional(),
        hasEscalation: z.boolean(),
        calledAgents: z.array(z.string()),
        userEmail: z.string(),
        iterationCount: z.number().optional(),
      }),
    ),
    totalCount: z.number(),
    allThreads: z.array(
      z.object({
        _id: z.string(),
        teamId: z.string().optional(),
        teamName: z.string().optional(),
        createdAt: z.date(),
        calledAgents: z.array(z.string()),
        userEmail: z.string(),
        hasEscalation: z.boolean(),
      }),
    ),
    metrics: z.object({
      totalThreads: z.number(),
      escalatedToHuman: z.number(),
      resolutionRate: z.number(),
      avgResponseTime: z.number(),
      totalTokensUsed: z.number(),
      avgTokensPerThread: z.number(),
      avgIterationsPerThread: z.number(),
    }),
  }),
};
